import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const STYLE_INSIGHTS_FRAGMENT = gql`
  fragment StyleInsights on StyleInsights {
    fixedText
    originalText
    violations {
      explanation
      text
    }
  }
`;

const MUTATION = gql`
  mutation ExtractAPStyleInsights($customerId: ID!, $text: String!) {
    extractApStyleInsights(customerId: $customerId, text: $text) {
      ...StyleInsights
    }
  }
  ${STYLE_INSIGHTS_FRAGMENT}
`;

export const extractAPStyleInsights = ({ customerId, text }, options) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, text },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
